import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';
import Typography from 'material-ui/Typography';
import VideoPlayer from './player';
import styles from './styles';

const FileView = props => {
	const {file, classes} = props;

	return (
		<React.Fragment>
			<div className={classes.description}>
				<Typography type="headline" component="h1">
					{file.name}
				</Typography>
				<Typography className={classes.desktopDescription} component="p">
					{file.description}
				</Typography>
			</div>
			<VideoPlayer file={file}/>
			<div className={classes.mobileDescription}>
				<Typography component="p">
					{file.description}
				</Typography>
			</div>
		</React.Fragment>
	);
};

FileView.propTypes = {
	classes: PropTypes.object.isRequired,
	file: PropTypes.object.isRequired
};

export default withStyles(styles)(FileView);



// WEBPACK FOOTER //
// ./src/client/components/main/files/video/video-view.jsx